<template>
  <div class="bg_blue">
    <div class="container_wrap">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <el-breadcrumb-item :to="{ path: '/indexpc' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item> 单位申请</el-breadcrumb-item>
      </el-breadcrumb>
      <el-alert title="温馨提示" type="error" class="elalert">
        1.请先登陆单位会员帐号或注册（注意只对机构单位会员，个人会员无法报名）<br />
        2.请您确保在整个申报流程中，您所填写的信息属实。<br />
      </el-alert>

      <div class="left_and_right_container">
        <div class="container_center">
          <el-form
            :model="formData"
            ref="ruleForm"
            :rules="rules"
            label-width="120px"
            class="demo-ruleForm"
          >
            <div class="apply_info_title">申报信息</div>
            <div
              class="apply_info_title_dialog"
              @click="dialogIntroVisible = true"
            >
              申报简介及要求
            </div>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="地区" prop="areas">
                  <!-- v-model="formData.areas" -->
                  <el-cascader
                    v-model="formData.areas"
                    :options="areaOptions"
                    :props="{ label: 'title' }"
                    class="inputSizeClass"
                    @change="handleChange"
                  ></el-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="学校全称" prop="name">
                  <el-input
                    type="text"
                    placeholder="请输入学校全称"
                    v-model="formData.name"
                    class="inputSizeClass"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="学校简称" prop="sname">
                  <el-input
                    type="text"
                    placeholder="请输入学校简称"
                    v-model="formData.sname"
                    class="inputSizeClass"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="校长姓名" prop="nickname">
                  <el-input
                    type="text"
                    placeholder="请输入校长姓名"
                    v-model="formData.nickname"
                    class="inputSizeClass"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="校长联系手机" prop="phone">
                  <el-input
                    type="text"
                    placeholder="请输入校长联系手机"
                    v-model="formData.phone"
                    class="inputSizeClass"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="申报人姓名" prop="lxname">
                  <el-input
                    type="text"
                    placeholder="请输入申报人姓名"
                    v-model="formData.lxname"
                    class="inputSizeClass"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="申报人联系手机" prop="lxphone">
                  <el-input
                    type="text"
                    placeholder="请输入申报人联系手机"
                    v-model="formData.lxphone"
                    class="inputSizeClass"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="申报人联系微信" prop="weixin">
                  <el-input
                    type="text"
                    placeholder="请输入申报人联系微信"
                    v-model="formData.weixin"
                    class="inputSizeClass"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="上传图片" prop="certificatepic">
                  <PicUploader
                    :fileList="formData.certificatepic"
                    :limit="5"
                    :name="'certificatepic'"
                  ></PicUploader>
                  <span class="el-note">请上传5张图片</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="申报理由" prop="applycontent">
                  <el-input
                    type="textarea"
                    autosize
                    placeholder="限300字以内，简要阐述学校艺术特色和开展条件，并上传艺术活动图片5张。"
                    v-model="formData.applycontent"
                    class="inputSizeClass"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col class="btn_position_class">
                <el-button type="primary" @click="ensureSubmit()"
                  >提交</el-button
                >
                <el-button @click="resetForm('ruleForm')" plain>重置</el-button>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </div>
    <ElPayDialog
      :show="payDialogShow"
      scene="yishujie"
      :ids="orderIds"
      @onPayError="onPayError"
      @onPaySuccess="onPaySuccess"
      @onPayClose="onPayClose"
    />

    <el-dialog
      title="申报简介及要求"
      :visible.sync="dialogIntroVisible"
      :destroy-on-close="true"
    >
      <el-alert type="warning" :closable="false">
        <template #title>
          <div v-html="danweiRequest.content"></div>
        </template>
      </el-alert>
    </el-dialog>

    <el-dialog
      title="提示"
      :visible.sync="centerDialogVisible"
      width="50%"
      center
    >
      <span>申报信息一旦提交成功后，不可修改！</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">返回修改</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import validator from "../../../utils/validator";
import NewsListItem from "@/components/listItem/NewsListItem";
import PicUploader from "@/components/picker/PicUploader";
import ElPayDialog from "@/components/ElPayDialog";
import { CountDown } from "vant";
import { dateFormat } from "../../../utils/date";
import XLSX from "xlsx";

Vue.use(CountDown);

export default {
  name: "CmsDetail",
  data() {
    return {
      centerDialogVisible: false,
      danweiRequest: "",
      dialogIntroVisible: false,
      areaOptions: [],
      payDialogShow: false,
      orderIds: [],
      type: JSON.parse(this.$route.query.type),
      rules: {
        name: [{ required: true, message: "请输入学校全称", trigger: "blur" }],
        sname: [{ required: true, message: "请输入学校简称", trigger: "blur" }],
        nickname: [
          { required: true, message: "请输入校长姓名", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入校长手机", trigger: "blur" },
          { validator: validator.phone, trigger: "blur" },
        ],
        lxname: [{ required: true, message: "请输入申报人姓名" }],
        lxphone: [
          { required: true, message: "请输入申报人手机" },
          { validator: validator.phone, trigger: "blur" },
        ],
        weixin: [{ required: true, message: "请输入申报人微信" }],
        certificatepic: [
          { required: true, message: "请上传图片", trigger: "blur" },
        ],
      },
      formData: {
        id: 0,
        type: 0,
        areas: [],
        group_id: "",
        saiqu_name: "",
        danwei: "",
        biaoyanleixing: "",
        jibie: "",
        phone: "",
        note: "",
        ldname: "",
        certificatepic: [],
        get_date: null,
        extra_course_id: "",
        grade: "",
        sname: "",
      },
      row: {
        id: 0,
        current_index: 0,
        question_list: [],
        user: {},
        kaoji: {},
      },
      courseOptions: [],
      service_options: [],
      trip_options: [],
    };
  },
  components: {
    NewsListItem,
    ElPayDialog,
    PicUploader,
  },

  filters: {},
  computed: {},
  mounted() {
    let that = this;
    that.formData.id = this.$route.query.id || 0;
    // this.fetch();
    // document.title = "联系人信息";
    that.getAreaOptions();
    this.getuserFun();
    this.handleJumpByidFun();
    this.fetchDialogInfo();
  },
  methods: {
    ensureSubmit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.centerDialogVisible = true;
        } else {
          //有必填项  未 填写
        }
      });
    },
    //根据type 获取单位的分类详情
    fetchDialogInfo() {
      var target_id;
      
      switch (Array.isArray(JSON.parse(this.$route.query.type))?parseInt(JSON.parse(this.$route.query.type)[0]):parseInt(this.$route.query.type)) {
        case 1:
          target_id = 119;
          break;
        case 2:
          target_id = 126;
          break;
        case 3:
          target_id = 120;
          break;
        default://case 4
          target_id = 127;
          break;
      }
      // console.log(target_id);
      // console.log(this.$route.query.type);
      this.$api.get(
        "api/cms/cateListItem",
        { id: target_id },
        (res) => {
          this.danweiRequest = res.data[0];
        },
        (err) => {
          console.log(err);
        }
      );
    },
    handleChange(value) {
      console.log(value);
      console.log(this.formData.areas);
    },
    //获取area的父级问题
    getareaParents(area_key) {
      this.$api.get(
        "/api/utils/areasByareakey",
        { area_key: area_key },
        (res) => {
          this.formData.areas = res;
        },
        (res) => {
          this.formData.areas = res;
        }
      );
    },

    //处理从详情 携带id进入页面
    handleJumpByidFun() {
      if (!this.$route.query.id) {
        return;
      }
      //获取单位详情
      this.$api.get(
        "/api/danwei/danweiDetail",
        { id: this.$route.query.id },
        (res) => {
          this.formData = res.data;
          this.getareaParents(res.data.area);
        },
        (err) => {
          console.log(err);
        }
      );
    },
    getuserFun() {
      this.$api.get(
        "/api/index/userdata",
        {},
        (res) => {
          console.log(res);
        },
        (err) => {
          console.log(err);
        }
      );
    },
    getAreaOptions() {
      let that = this;
      that.$api.post("/api/utils/areaTree", {}, (r) => {
        that.areaOptions = r.data;
      });
    },
    // fetch() {
    //   let that = this;
    //   that.$api.get(
    //     "/api/danwei/applydetail",
    //     {
    //       type: that.type,
    //     },
    //     (res) => {
    //       setTimeout(() => {
    //         if (res.data.area) {
    //           res.data.areas = [
    //             res.data.area.substring(0, 2) + "0000",
    //             res.data.area.substring(0, 4) + "00",
    //             res.data.area,
    //           ];
    //         } else {
    //           res.data.areas = [];
    //         }
    //       }, 500);
    //       // if(that.formData.id){
    //       that.formData = res.data;
    //       // }

    //       console.log("Dialog");
    //     },
    //     (res) => {
    //       console.log("没有登录");
    //       if (res.code == 401 || res.code == 402) {
    //         if (window.isApp()) {
    //           rbLink(
    //             {
    //               name: "login",
    //               query: {},
    //             },
    //             "replace"
    //           );
    //           return false;
    //         }
    //         that.loginShow = true;
    //       } else {
    //         that.$message.error(res.msg);
    //       }
    //     }
    //   );
    // },
    submitForm(formName) {
      const that = this;
      console.log(that.formData.areas);
      if (that.formData.areas && that.formData.areas.length != 3) {
        that.$message.error("请选择省市");
        return;
      }
      that.formData.type = that.type;
      console.log(that.formData.areas);
      that.formData["area"] = that.formData.areas[2];
      that.formData.registstatus = 1; //待审核
      that.$refs[formName].validate((valid) => {
        if (valid) {
          // that.formData.get_date = that.formData.get_date_m.format('YYYY-MM-DD');
          that.$api.post("/api/danwei/apply", that.formData, (r) => {
            that.$message.success("保存成功");
            that.formData.id = r.data.id;
            this.$router.push({ path: "/danweiApplyList" });
            // that.$router.push({name:'KaojiExame',query:{
            //   kaoji_id:r.data.id
            //   }})
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    onPayError() {
      let that = this;
      console.log("onPayError 支付失败");
      that.payDialogShow = false;

      that.$toast("支付失败");

      rbLink(
        {
          name: "yishujieApplyList",
        },
        "replace"
      );
    },
    onPaySuccess() {
      let that = this;
      console.log("onPaySuccess 支付成功");
      that.payDialogShow = false;

      appEvent({
        name: "saiApplyDetailReload",
        query: {},
      });

      setTimeout(function () {
        rbLink(
          {
            name: "yishujieApplyList",
            query: {},
          },
          "replace"
        );
      }, 500);
    },
    onPayClose() {
      let that = this;
      console.log("onPayClose 支付关闭");
      that.payDialogShow = false;

      setTimeout(function () {
        rbLink(
          {
            name: "yishujieApplyList",
          },
          "replace"
        );
      }, 500);
    },
  },
};
</script>
<style scoped lang="scss">
.apply_info_title {
  font-size: 20px;
  font-weight: bold;
  display: inline-block;
}
.apply_info_title_dialog {
  font-size: 12px;
  font-weight: normal;
  display: inline-block;
  margin-left: 15px;
  color: #1981ff;
  cursor: pointer;
  margin-bottom: 10px;
  &:hover {
    opacity: 0.86;
    text-decoration: underline;
  }
}
.status-1 {
  background: #559f07;
  color: #fff;
}
.status-2 {
  background: #e02020;
  color: #fff;
}
.status-0 {
  background: #f4faff;
  color: #666666;
}
.bg_blue {
  width: 100%;
  background: #f4faff;
  height: 100%;
  overflow: hidden;
}
.container_wrap {
  width: 1240px;
  margin: 0 auto;
  margin-bottom: 30px;
  // height: 1235px;
}
.breadcrumb {
  margin-top: 21px;
  margin-left: 23px;
  margin: 21px 0 20px 23px;
}
.elalert {
  margin: 0 0 40px 0;
}
.elsteps {
  margin: 0 0 25px 0;
}
.left_and_right_container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .container_left {
    width: 212px;
    min-height: 560px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 32px;
    .container_left_content {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin: 88px 0 0 0;
      .container_left_content_img {
        width: 108px;
        height: 108px;
        border-radius: 8px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          border: none;
          object-fit: cover;
        }
      }
      .container_left_content_name {
        margin: 16px 0;
        height: 20px;
        font-size: 14px;

        font-weight: 500;
        color: #333333;
        line-height: 20px;
        span {
          color: #666666;
        }
      }
      .container_left_content_serve {
        display: flex;
        align-items: center;
        line-height: 17px;
        font-size: 12px;

        font-weight: 400;
        color: #0091ff;
        .el-icon-service {
          margin: 0 9px 0 0;
          font-size: 17px;
        }
        &:hover {
          cursor: default;
          font-weight: bold;
        }
      }
    }
  }
  .container_center {
    width: 1240px;
    min-height: 560px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 32px;
    padding-top: 24px;
    padding: 88px 0 30px 29px;
    box-sizing: border-box;
    .inputSizeClass {
      width: 240px;
      height: 40px;
      border-radius: 4px;
    }
    .btn_position_class {
      text-align: center;
      margin: 42px 0 0 0;
      box-sizing: border-box;
      /deep/.el-button {
        width: 139px;
        height: 44px;
        border-radius: 22px;
        font-size: 14px;
      }
    }
  }

  .container_right {
    width: 296px;
    min-height: 560px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 32px;
  }
}
</style>


// WEBPACK FOOTER //
// DanweiApplyForm.vue?08a9b063